import { ComparisonRuleType } from "@/types/validationTypes";

export const comparisonCharaterFromRuleType = (ruleType: ComparisonRuleType) => {
  switch (ruleType) {
    case ComparisonRuleType.EQUAL:
      return '=';
    case ComparisonRuleType.LESS_THAN:
      return '<';
    case ComparisonRuleType.GREATER_THAN:
      return '>';
    case ComparisonRuleType.NOT_EQUAL:
      return '≠';
    case ComparisonRuleType.LESS_THAN_OR_EQUAL:
      return '≤';
    case ComparisonRuleType.GREATER_THAN_OR_EQUAL:
      return '≥';
    case ComparisonRuleType.RANGE:
      return 'Range';
    default:
      return 'Invalid Rule Type';
  }
};

export const ruleTypeFromChar = (char: string) => {
  switch (char) {
    case '=':
      return ComparisonRuleType.EQUAL;
    case '<':
      return ComparisonRuleType.LESS_THAN;
    case '>':
      return ComparisonRuleType.GREATER_THAN;
    case '≠':
      return ComparisonRuleType.NOT_EQUAL;
    case '≤':
      return ComparisonRuleType.LESS_THAN_OR_EQUAL;
    case '≥':
      return ComparisonRuleType.GREATER_THAN_OR_EQUAL;
    case 'Range':
      return ComparisonRuleType.RANGE;
    default:
      throw new Error('Invalid Rule Type');
  }
};
